module.exports = __webpack_public_path__ + "img/logo_text_en.131ee1bd.png";